export const convertToDecimal = (curr) => {
  const currency = curr?.toLocaleString("en-US", {
    style: "decimal",
    maximumFractionDigits: 2,
  });
  return currency;
};
